const ENDPOINTS = {
      AUTH_LOGIN: '/oauth/token',
      USER_OPERATORS: '/api/grupos-info?_format=json',
      OPERATORS_USER: (userId) => `/json_app_oktv/operadores_del_usuario_conectado/${userId}?_format=json`,
      OPERATOR_USERS: (operatorId) => `/restv1.0/operator/${operatorId}/users?_format=json`,
      OPERATOR_CHANNELS: (operatorId) => `/json_app_oktv/canales/${operatorId}?_format=json`,
      OPERATOR_BANNERS: (operatorId) => `/dashboard/banners/${operatorId}?_format=json`,
      CREATE_USER_IN_OPERATOR: '/api/user-group-manager?_format=json',
      DELETE_USER_IN_OPERATOR: (operatorId, userId) => `/api/user-group-manager/${userId}/group/${operatorId}?_format=json`,
      EDIT_USER_IN_OPERATOR: (userId) => `/api/user-group-manager/${userId}?_format=json`,
      EDIT_NODE: (nodeId) => `/node/${nodeId}?_format=json`,
      DELETE_NODE: (nodeId) => `/node/${nodeId}?_format=json`,
      CREATE_NODE: '/node?_format=json',
      UPLOAD_FILE: (entityId, contentType, fieldName) => `/file/upload/${entityId}/${contentType}/${fieldName}?_format=json`,
      ASSIGN_CONTENT_TO_GROUP: '/api/group-content/assign?_format=json',
      GET_USER: (userId) => `/user/${userId}?_format=json`,
      EDIT_USER: (userId) => `/user/${userId}?_format=json`,
      BASIC_PARAMS: '/api/configuracion-json/parametros-basicos?_format=json',
}

export default ENDPOINTS;